import React, { useState } from 'react';
import { ProductCard } from './ProductCard';
const products = [{
  id: 1,
  name: 'Festive Wreath with Pine Cones',
  price: 34.99,
  image: 'https://images.unsplash.com/photo-1543589077-47d81606c1bf?w=500&q=80',
  category: 'Wreaths'
}, {
  id: 2,
  name: 'Elegant Nutcracker Soldier',
  price: 45.99,
  image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?w=500&q=80',
  category: 'Figurines'
}, {
  id: 3,
  name: 'Golden Ornament Set',
  price: 28.99,
  image: 'https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=500&q=80',
  category: 'Ornaments'
}, {
  id: 4,
  name: 'Cozy Winter Village Scene',
  price: 89.99,
  image: 'https://images.unsplash.com/photo-1544273677-1cb3e6d0f52e?w=500&q=80',
  category: 'Decorations'
}, {
  id: 5,
  name: 'Premium Christmas Tree 6ft',
  price: 129.99,
  image: 'https://images.unsplash.com/photo-1606854428728-5fe3eea23475?w=500&q=80',
  category: 'Trees'
}, {
  id: 6,
  name: 'Festive Table Runner',
  price: 24.99,
  image: 'https://images.unsplash.com/photo-1482517967863-00e15c9b44be?w=500&q=80',
  category: 'Table Decor'
}, {
  id: 7,
  name: 'LED String Lights Warm White',
  price: 19.99,
  image: 'https://images.unsplash.com/photo-1576919228236-a097c32a5cd4?w=500&q=80',
  category: 'Lights'
}, {
  id: 8,
  name: 'Santa Claus Figurine Large',
  price: 54.99,
  image: 'https://images.unsplash.com/photo-1512909006721-3d6018887383?w=500&q=80',
  category: 'Figurines'
}, {
  id: 9,
  name: 'Rustic Wooden Star Decor',
  price: 32.99,
  image: 'https://images.unsplash.com/photo-1544982503-9f984c14501a?w=500&q=80',
  category: 'Decorations'
}, {
  id: 10,
  name: 'Holiday Candle Gift Set',
  price: 39.99,
  image: 'https://images.unsplash.com/photo-1602874801006-e26c4a4a9d5e?w=500&q=80',
  category: 'Candles'
}, {
  id: 11,
  name: 'Snowman Family Set',
  price: 42.99,
  image: 'https://images.unsplash.com/photo-1546538994-cc8e0d7d3e8e?w=500&q=80',
  category: 'Figurines'
}, {
  id: 12,
  name: 'Red Velvet Stockings Set of 4',
  price: 36.99,
  image: 'https://images.unsplash.com/photo-1544982503-9f984c14501a?w=500&q=80',
  category: 'Stockings'
}];
const categories = ['All Products', 'Wreaths', 'Trees', 'Ornaments', 'Lights', 'Figurines', 'Decorations', 'Table Decor', 'Stockings', 'Candles'];
export function ProductGrid() {
  const [selectedCategory, setSelectedCategory] = useState('All Products');
  const filteredProducts = selectedCategory === 'All Products' ? products : products.filter(p => p.category === selectedCategory);
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-146">
      {/* Category Filter */}
      <div className="mb-8" data-id="element-147">
        <div className="flex flex-wrap gap-2" data-id="element-148">
          {categories.map(category => <button key={category} onClick={() => setSelectedCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition ${selectedCategory === category ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-149">
              {category}
            </button>)}
        </div>
      </div>
      {/* Products Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-150">
        {filteredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-151" />)}
      </div>
    </div>;
}